import { render, staticRenderFns } from "./PasswordPage.vue?vue&type=template&id=4f0bc2ed&"
import script from "./PasswordPage.vue?vue&type=script&lang=js&"
export * from "./PasswordPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports